export default "__VITE_ASSET__CDvwbZof__"